export default "/images/link-2.svg?de4fc6c735a8c59de2ce9e3153caadaf";